export const NetworksEnum = Object.freeze({ "liveNet": 0, "testNet": 1, "customNet": 3 })
export default () => ({
    networkType: NetworksEnum.liveNet,
    apiUrl: process.env.VUE_APP_PUBLIC_NETWORK,
    darkMode : false
})
